module.exports = __webpack_public_path__ + "img/bg_welfare.5bbc79ca.jpg";